import {
    GeneralBlock,
    GeneralBlockBody,
    GeneralBlockHeader,
    GeneralBlockTitle,
    GeneralBlockValue,
} from 'src/registry/components/blocks/GeneralBlock';
import { SectionBlockBody } from 'src/registry/components/blocks/SectionBlock';

import type { ReactNode } from 'react';

type StatisticCardsProps = {
    cardData: {
        title: string;
        subtitle?: string;
        value?: string | number | null;
    }[];
    children?: ReactNode;
};

export default function StatisticsCards({ cardData, children }: StatisticCardsProps) {
    return (
        <SectionBlockBody className="grid auto-rows-fr sm:grid-cols-2 sm:flex-row lg:grid-cols-4">
            {cardData.map((card) => {
                return (
                    <GeneralBlock className="flex-1 gap-2" key={card.title}>
                        <GeneralBlockHeader variant="dashboard">
                            <GeneralBlockTitle className="flex-1">
                                {card.title}
                                {card.subtitle ? (
                                    <div className="flex items-center text-sm text-gray-500">{card.subtitle}</div>
                                ) : (
                                    <div className="h-5" />
                                )}
                            </GeneralBlockTitle>
                        </GeneralBlockHeader>
                        <GeneralBlockBody variant="dashboard">
                            <GeneralBlockValue className="flex items-end" size="small">
                                {card.value}
                            </GeneralBlockValue>
                        </GeneralBlockBody>
                    </GeneralBlock>
                );
            })}
            {children || null}
        </SectionBlockBody>
    );
}
